import axios from "axios";
import React, { Component } from "react";
import AlertPopup from './AlertPopup'; // adjust path if in a different folder
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      mobile: "",
      subject: "",
      message: "",
      errors: {},
      showAlert: false,
      alertTitle: '',
      alertMessage: '',
      alertType: '', // success or error
      alertIcon: null,
    };
  }

  // Handle input changes
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  // Handle form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { subject, name, email, mobile, message } = this.state;
    // Check if any field is empty
    if (!subject || !name || !email || !mobile || !message) {
      this.setState({
      showAlert: true,
      alertTitle: 'ERROR',
      alertMessage: 'Please fill all details',
      alertType: 'error',
      alertIcon: faTimesCircle,
      });
      return;
    }
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const requestBody = {
      subject: this.state.subject,
      department: "LQE",
      name: this.state.name,
      email: this.state.email,
      mobile: this.state.mobile,
      message: this.state.message,
      cc_emails: ["lqe.dev.2025@gmail.com"],
      to_emails: ["info@learnquraneasily.in"],
    };
    axios
      .post(`${BackendUrl}/Contact-Us`, requestBody)
      .then((response) => {
        // alert("Message sent!");
        this.setState({
          name: "",
          email: "",
          mobile: "",
          subject: "",
          message: "",
          errors: {},
          showAlert: true,
          alertTitle: 'SUCCESS',
          alertMessage: 'Your message has been sent successfully.',
          alertType: 'success',
          alertIcon: faCheckCircle,
        });
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        // alert("Failed to send message.");
        this.setState({
        showAlert: true,
        alertTitle: 'ERROR',
        alertMessage: 'Failed to send message. Please try again later.',
        alertType: 'error',
        alertIcon: faTimesCircle,
      });
      });
  };

  render() {
  const { name, email, subject, message, mobile, alertTitle, alertMessage, alertIcon, alertType } = this.state;
    const storedLangSlug = localStorage.getItem("siteLanguage");

    return (
      <div className="container-fluid contact py-3">
        <div className="container">
          <div
            className="text-center mx-auto mb-3 wow fadeIn"
            data-wow-delay="0.1s"
            style={{ maxWidth: "700px" }}
          >
            <p className="fs-5 text-uppercase text-primary">
              {storedLangSlug === "ur" ? "رابطہ کریں۔" : "Get In Touch"}
            </p>
            <h1>
              {storedLangSlug === "ur"
                ? "کسی بھی سوال کے لیے رابطہ کریں۔"
                : "Contact For Any Queries"}
            </h1>
            {/* <p className="mb-0">
              The contact form is currently inactive. Get a functional and working contact form with Ajax & PHP in a few minutes. Just copy and paste the files, add a little code, and you're done.{' '}
              <a
                href="https://htmlcodex.com/contact-form"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Now
              </a>
              .
            </p> */}
          </div>
          <form onSubmit={this.handleSubmit}>
            <div className="row g-4 wow fadeIn" data-wow-delay="0.3s">
              <div className="col-sm-6">
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="Your Name"
                  name="name"
                  value={name}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-sm-6">
                <input
                  type="email"
                  className="form-control bg-transparent p-3"
                  placeholder="Your Email"
                  name="email"
                  value={email}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-6">
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  placeholder="Subject"
                  name="subject"
                  value={subject}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-6">
                <input
                  type="number"
                  className="form-control bg-transparent p-3"
                  placeholder="Mobile"
                  name="mobile"
                  value={mobile}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-12">
                <textarea
                  className="w-100 form-control bg-transparent p-3"
                  rows="6"
                  cols="10"
                  placeholder="Your Message"
                  name="message"
                  value={message}
                  onChange={this.handleChange}
                ></textarea>
              </div>
              <div className="col-12 text-center">
                <button
                  className="btn btn-primary border-0 py-3 px-5"
                  type="submit"
                >
                  Send Message
                </button>
              </div>
            </div>
          </form>
          {/* Alert Popup */}
        {this.state.showAlert && (
          <AlertPopup
            title={alertTitle}
            message={alertMessage}
            icon={alertIcon}
            type={alertType}
            onClose={() => this.setState({ showAlert: false })}
          />
        )}
        </div>
      </div>
      
    );
  }
}

export default ContactForm;
